const getDefaultState = () => {
  return {
    cdRaws: {},
  };
};

const state = getDefaultState();

const mutations = {
  SET_CATEGORY_DEFINITIONS(state, payload) {
    state.cdRaws = payload;
  },
};

const actions = {};

export default {
  state,
  mutations,
  actions,
};
